<template>
    <div class="h-full overflow-y-auto w-full">
        <div id="assets" class="grid gap-2 h-full justify-between pr-1">
            <template v-if="assets.length > 0">
            <c-asset-download v-for="asset in assets"
                              @onClick="activeAsset=asset"
                              @onClickDownload="downloadImage(asset.asset, asset.filename)"
                              v-if="getAsset(asset.type)" :title="asset.type"
                              :url="asset.assetLow"></c-asset-download>
            </template>
            <p v-else>No assets with matching dimensions to display</p>
        </div>

        <c-asset-popup v-if="activeAsset!== null" @onClose="activeAsset = null"
                       :asset="activeAsset.assetLow"
                       :name="activeAsset.filename"
                       @onClickDownload="downloadImage(activeAsset.asset, activeAsset.filename); activeAsset=null"></c-asset-popup>
    </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import AssetDownload from "../AssetDownload";
import AssetPopup from "../../../templates/AssetPopup";
import download from "../../../mixins/download";

export default {
    name: "ProductDownloadForm",

    components: {
        'c-asset-download': AssetDownload,
        'c-asset-popup': AssetPopup,
    },

    mixins: [getTranslation, download],

    props: {
        assets: {required: true},
        product: {required: true},
    },

    data() {
        return {
            activeAsset: null,
            assetsDownloading: false,
        }
    },

    methods: {
        getAsset(key) {
            return this.assets.find((asset) => {
                return asset.type === key
            })
        },
    }
}
</script>
<style scoped>
#assets {
    grid-template-columns: repeat(auto-fill, 350px);
    height: 100% !important;
}
</style>
